import { apiFetch } from '@/lib/api';
import { getJson, useQuery } from '@/lib/query';

/** One Director-chat message as /api/chat returns it. */
export interface ChatApiMessage {
  id: string;
  kind?: string;
  status?: string;
  text?: string;
  action?: { type?: string; target?: string; note?: string; summary?: string } | null;
  [key: string]: unknown;
}

export interface ChatData {
  messages: ChatApiMessage[];
}

const CHAT_POLL_MS = 8000;

export const chatKey = (productionId: string) => `chat:${productionId}`;

/**
 * The production's Director chat, cached and shared: the review gate (rework
 * flags) and the Work Queue both read it, and used to poll /api/chat separately.
 * Polls only while the production runs; pass null to disable.
 */
export function useProductionChat(productionId: string | null, running: boolean) {
  return useQuery<ChatData>(
    productionId ? chatKey(productionId) : null,
    () => getJson<ChatData>(() => apiFetch(`/api/chat/${productionId}`)),
    { intervalMs: running ? CHAT_POLL_MS : undefined },
  );
}
